module.exports = __webpack_public_path__ + "assets/ico-timer.0eb8a5d0.svg";